export default __webpack_public_path__ + "static/media/multiply_white.de8a7618.svg";